import "./TrackTimeline.css";

export default function TrackTimeline({ tracks, displayForm }) {
  return (
    <div className="track-timeline">
    <div className="student-experience">
      <h3>Student's Experience</h3>
      <p>
        Whether you want to pursue a career as a technologist, a Freelancer
        or an Entrepreneur, this program prepares you adequately for that. This
        is an immersive, collaborative and intensive porgam, prepared in a way
        to help you apply what you learn in real-time through project-based
        learning.
      </p>
    </div>
      <div className="track-timeline-img">
        {/* <img src="../images/geegstack-timeline.png" /> */}
      </div>
      <ul className="track-timelines-items">
        {tracks.map((val, ind) => {
          return (
            <li key={ind} className="track-timelines-item">
              <p className="track-timeline-header">{val.header}</p>
              <p className="track-timeline-content">{val.content}</p>
            </li>
          );
        })}
      </ul>
      <button className="track-timeline-btn" onClick={displayForm}>Get Program Package</button>
    </div>
  );
}
